import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {CellComponent} from "@shared/components/cell-components/cell-component";
import {FieldDefinition} from "@shared/models/field-definition";

@Component({
    standalone: false,
    selector: 'app-download-memo-cell-viewer',
  templateUrl: './download-memo-cell-viewer.component.html',
  styleUrls: ['./download-memo-cell-viewer.component.scss']
})
export class DownloadMemoCellViewerComponent implements OnInit, CellComponent {

  fieldDefinition: FieldDefinition;
  item: any;
  @Output() valueChanged: EventEmitter<any> = new EventEmitter<any>();


  constructor() { }

  ngOnInit(): void {
  }

  onClicked(action: string) {
    this.valueChanged.emit({item: this.item, fieldDefinition: this.fieldDefinition, action: {id: action}});
  }
}
